<template>
    <vs-row>
        <vs-row class="settingsBgClr mx-4">
        <vs-row>
            <h3 class="p-5 pb-0">Account Settings</h3>
        </vs-row>
        <vs-row class="p-2">
              <vs-row class="p-5 pl-0 ml-3 m-5 mb-1">
                    <vs-col vs-lg="4" vs-sm="5">
                        <div @click="$refs.uploadSettings.click()" class="uploadLabelSettings">{{ selectedFileName ? selectedFileName : 'Upload Profile Photo' }}</div>
                        <input type="file" class="hidden" ref="uploadSettings" @change="showFilePath">
                    </vs-col>

                    <vs-col vs-lg="2" class="uploadContainerSettings">
                            <div class="btn-addon">
                            <vs-button size="small" color="primary" @click="$refs.uploadSettings.click()">
                                <UploadCloudIcon />
                            </vs-button>
                        </div>
                    </vs-col>
                </vs-row>
                <vs-row>
                    <div class="dangerColor ml-3">{{ errors.photo.msg }}</div>
                </vs-row>
        </vs-row>
        <vs-col vs-lg="6" vs-sm="12" class="inputContainer">
             <vs-row>
            <div class="ml-5 mt-4">
                First Name <span v-if="errors.firstName.success" class="sterik">*</span>
                <span v-if="!errors.firstName.success"> *</span>                                                                                            
            </div>
            </vs-row>
            <vs-input 
             class="w-full p-2 pl-4"
              v-model="updateAdmin.fname"
              :danger="errors.firstName.success"
               :danger-text="errors.firstName.msg"
               @input="validateFirstName($event)"
               @keypress="validateAlpha($event)"
               maxLength="40"/>
        </vs-col>
        <vs-col vs-lg="6" vs-sm="12" class="inputContainer">
            <vs-row>
            <div class="ml-5 mt-4">
                Last Name <span v-if="errors.lastName.success" class="sterik">*</span>
                <span v-if="!errors.lastName.success"> *</span>                                                                                            
            </div>
            </vs-row>
            <vs-input 
            class="w-full p-2 pl-4"
             v-model="updateAdmin.lname"
             :danger="errors.lastName.success"
              :danger-text="errors.lastName.msg"
              @input="validateLastName($event)"
              @keypress="validateAlpha($event)"
              maxLength="40"/>
        </vs-col>
        <vs-row class="inputContainer">
            <vs-row>
            <div class="ml-5 mt-6">
                Email <span v-if="errors.email.success" class="sterik">*</span>
                <span v-if="!errors.email.success"> *</span>                                                                                            
            </div>
            </vs-row>
            <vs-input 
            class="w-full p-2 pl-4" 
            v-model="updateAdmin.email"
             :danger="errors.email.success"
             :danger-text="errors.email.msg"
             @input="validateEmail($event)"
             autocomplete="off"
             maxLength="40"  />
        </vs-row>
        <vs-col vs-lg="6" vs-sm="12" class="inputContainer" id="p">
            <vs-row>
            <div class="ml-5 mt-6">
                Password <span v-if="errors.password.success" class="sterik">*</span>
            </div>
            </vs-row>
            <vs-input 
            class="w-full p-2 pl-4" 
            v-model="updateAdmin.password" 
            type="password"
            :danger="errors.password.success"
             :danger-text="errors.password.msg"
             maxLength="40"
             placeholder="********"
              autocomplete="off"
            />
        </vs-col>
        <vs-col vs-lg="6" vs-sm="12" class="inputContainer" id="p">
            <vs-row>
            <div class="ml-5 mt-6">
                Confirm New Password <span v-if="errors.password2.success" class="sterik">*</span>
            </div>
            </vs-row>
            <vs-input 
            class="w-full p-2 pl-4" 
            v-model="updateAdmin.confirmP"
             type="password"
             :danger="errors.password2.success"
             :danger-text="errors.password2.msg"
             maxLength="40"
             placeholder="********"
             autocomplete="off"
             />
        </vs-col>
        <vs-row class="p-5 pl-0 ml-3 m-5" vs-justify="center">
            <vs-button @click="editAdmin">Save Changes</vs-button>
        </vs-row>
        <vs-popup class="holamundo"  title="Result" :active.sync="updateStatus">
            <h5>Your profile has been updated successfully</h5>
        </vs-popup>
    </vs-row>
    </vs-row>
</template>

<script>
    import { UploadCloudIcon } from 'vue-feather-icons';
    import EventBus from '@/event-bus.js';

      import { validateFirstName, validateLastName, validateEmail, onAccountSettings, validateAlpha
    } from '@/views/admin/validation';
    
    import { genericErrorMessage, toast } from '@/keys/toast-messages';

    export default {
        components: {
            UploadCloudIcon
        },
        data(){
            return {
                updateAdmin: {
                    fname: '',
                    lname: '',
                    email: '',
                    password: '',
                    confirmP: '',
                    photo: ''
                },
                selectedFileName: '',

                updateStatus: false,

                errors: {
                    firstName: {
                        msg: '',
                        success: false
                    },
                    lastName: {
                        msg: '',
                        success: false
                    },
                    email: {
                        msg: '',
                        success: false
                    },
                    password: {
                        msg: '',
                        success: false
                    },
                    password2: {
                        msg: '',
                        success: false
                    },
                    photo: {
                        msg: '',
                        success: false
                    }
                },
                validateFirstName,
                validateLastName,
                validateEmail,
                onAccountSettings,
                validateAlpha,

                genericErrorMessage,
                toast
            }
        },
        methods: {
            showFilePath(){
                if(this.$refs.uploadSettings.files[0]){
                    this.selectedFileName = this.$refs.uploadSettings.files[0].name;
                    let format = this.$refs.uploadSettings.files[0].type.split('/').pop();
                    if(this.$refs.uploadSettings.files[0].size/1048576 > this.$maxFileSize){
                        this.errors.photo = {
                            msg: 'Photo size must be less than '+this.$maxFileSize+' MB',
                            success: true
                        }
                    }
                    else {
                        this.errors.photo = {
                            msg: '',
                            success: false
                        }
                        if(!this.$photoFormats.includes(format)){
                            this.errors.photo = {
                                msg: 'Please select a valid photo format',
                                success: true
                            }
                        }
                        else {
                            this.errors.photo = {
                                msg: '',
                                success: false
                            }
                        }
                    }
                    this.updateAdmin.photo = this.$refs.uploadSettings.files[0];
                }
                else {
                    this.errors.photo = {
                        msg: '',
                        success: false
                    }
                    this.selectedFileName = '';
                }
            },
            editAdmin(){
                if(this.onAccountSettings() && !this.errors.photo.success){
                      this.$vs.loading({
                        background: 'rgba(1,2,3,.2)'
                    });
                    const userId = JSON.parse(localStorage.getItem('user'))&& 
                                    JSON.parse(localStorage.getItem('user'))._id
                    var data = new FormData();
                    data.append('firstname',this.updateAdmin.fname);
                    data.append('lastname',this.updateAdmin.lname);
                    data.append('email',this.updateAdmin.email);
                    this.updateAdmin.password && this.updateAdmin.password && data.append('newPassword',this.updateAdmin.password);
                    data.append('photo',this.updateAdmin.photo);
                    return new Promise((resolve, reject) => {
                        this.$axios.patch( this.$ApiKeys.BASE_URL + 
                            this.$EndPoints.Users + this.$EndPoints.UsersSettings + "/" + userId,
                            data
                            ).then(async res => {
                            this.$vs.loading.close();
                            this.updateAdmin.password = '';
                            this.updateAdmin.confirmP = '';
                            if(res.status == 200){
                                this.updateStatus = true;
                                this.$localStorage.set('user',JSON.stringify(res.data.data));
                                let usr = JSON.parse(this.$localStorage.get('user'));
                                EventBus.$emit('userInfo',usr);
                                this.errors =  {
                                    firstName: {
                                        msg: '',
                                        success: false
                                    },
                                    lastName: {
                                        msg: '',
                                        success: false
                                    },
                                    email: {
                                        msg: '',
                                        success: false
                                    },
                                    password: {
                                        msg: '',
                                        success: false
                                    },
                                    password2: {
                                        msg: '',
                                        success: false
                                    },
                                    photo: {
                                        msg: '',
                                        success: false
                                    }
                                }
                            } else {
                                this.toast(this.genericErrorMessage());      
                            }
                        }).catch(e => {
                            this.$vs.loading.close();
                            if(e.response.data.errors.email){
                                this.errors.email = {
                                    msg: e.response.data.errors.email,
                                    success: true
                                }
                            }
                            else {
                                this.errors.email = {
                                    msg: '',
                                    success: false
                                }
                            }
                            if(e.response.data.errors.password){
                                this.errors.password = {
                                    msg: e.response.data.errors.password,
                                    success: true
                                }
                            }
                            else {
                                this.errors.password = {
                                    msg: '',
                                    success: false
                                }
                            }
                            if(!e.response.data.errors.email && !e.response.data.errors.password){
                                if(e.response.status !== 401){
                                    this.toast(this.genericErrorMessage());
                                }      
                            }
                        });
                    });
                }
            },
        },
        async created(){
            let user = await JSON.parse(this.$localStorage.get('user'));
            this.updateAdmin.fname = user.firstname;
            this.updateAdmin.lname = user.lastname;
            this.updateAdmin.email = user.email;
            EventBus.$emit('resetToggleGroup',true);
        }
    }
</script>


<style>
    @import './style.css';
</style>